<template>
    <!-- GALLERY-->
    <section class="page-section bg-secondary" id="portfolio">
        <div class="container">
            <div class="text-center">
                <h2 class="section-heading text-uppercase text-white">GALLERY</h2>
                <!--<h3 class="section-subheading text-muted">Lorem ipsum dolor sit amet consectetur.</h3>-->
            </div>
            <div class="row">
                <div
                v-for="album in albums" 
                v-bind:key="album"
                class="col-lg-4 col-sm-6 mb-4">
                    <div class="portfolio-item">
                        <a class="portfolio-link" data-bs-toggle="modal" :href="`#portfolioModal${album.id}`">
                            <div class="portfolio-hover">
                                <div class="portfolio-hover-content"><i class="fas fa-plus fa-3x"></i></div>
                            </div>
                            <img class="img-fluid" :src="album.image" alt="..." />
                        </a>
                        <div class="portfolio-caption">
                            <div class="portfolio-caption-heading">{{ album.heading }}</div>
                            <div class="portfolio-caption-subheading text-muted">{{ album.subheading }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    
    <!-- Portfolio Modals-->    
    <div
        v-for="album in albums" 
        v-bind:key="album">
        <div class="portfolio-modal modal fade" :id="`portfolioModal${album.id}`" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="close-modal" data-bs-dismiss="modal"><img src="@/assets/img/close-icon.svg" alt="Close modal" /></div>
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="">
                                <div class="modal-body">
                                    <h2 class="text-uppercase">{{ album.title }}</h2>
                                    <p class="item-intro text-muted">{{ album.intro }}</p>
                                    <!-- Filled by javascript buildAlbums-->
                                    <GalleryModal :folder="album.id" />
                                    <div :id="`portfolioModal${album.id}`"></div>
                                    <button class="btn btn-primary btn-xl text-uppercase" data-bs-dismiss="modal" type="button">
                                        <i class="fas fa-xmark me-1"></i>
                                        Close Gallery
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
   </div>
</template>

<script setup lang="ts">
import GalleryModal from '@/components/GalleryModal.vue'
import { albums } from '@/data/albums'
</script>

<style>
#portfolio .portfolio-item .portfolio-link .portfolio-hover {
    background: rgba(230, 216, 28, 0.9);
}
</style>